import { css } from 'styled-components';

export const saTheme = css`
    --color-primary: #005693;
    
    --color-state-primary: rgba(0, 86, 147, 0.07);
    --color-state-secondary: rgba(0, 86, 147, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: rgb(0, 86, 147);

    /* Home Page */
    --home-hero-background: linear-gradient(196deg, #0864A6 21.87%, #005693 78.13%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #EDFBFF;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
